/** Hold `data-wp-pressing` after pointer-up so press fill stays visible briefly. Action is not delayed. */
export const PRESS_FEEDBACK_MS = 90;

type MatchMedia = (query: string) => { matches: boolean };

/** Visual press hold in ms. 0 when `prefers-reduced-motion: reduce`. */
export function resolvePressFeedbackDelayMs(
  matchMedia: MatchMedia | undefined =
    typeof globalThis !== 'undefined' &&
    typeof (globalThis as { matchMedia?: MatchMedia }).matchMedia === 'function'
      ? (globalThis as { matchMedia: MatchMedia }).matchMedia.bind(globalThis)
      : undefined,
): number {
  if (!matchMedia) return PRESS_FEEDBACK_MS;
  try {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return 0;
  } catch {
    /* ignore */
  }
  return PRESS_FEEDBACK_MS;
}
